/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bespoke_Manual_OverrideInputs */

const en_bespoke_manual_override = /** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespoke Manual Override`)
};

const id_bespoke_manual_override = /** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggantian Manual Kustom`)
};

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const es_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const fr_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const de_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const ja_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const zh_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const ar_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const it_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const ru_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const pt_bespoke_manual_override = en_bespoke_manual_override;

/** @type {(inputs: Bespoke_Manual_OverrideInputs) => LocalizedString} */
const ko_bespoke_manual_override = en_bespoke_manual_override;

/**
* | output |
* | --- |
* | "Bespoke Manual Override" |
*
* @param {Bespoke_Manual_OverrideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bespoke_manual_override = /** @type {((inputs?: Bespoke_Manual_OverrideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bespoke_Manual_OverrideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bespoke_manual_override(inputs)
	if (locale === "es") return es_bespoke_manual_override(inputs)
	if (locale === "fr") return fr_bespoke_manual_override(inputs)
	if (locale === "de") return de_bespoke_manual_override(inputs)
	if (locale === "ja") return ja_bespoke_manual_override(inputs)
	if (locale === "zh") return zh_bespoke_manual_override(inputs)
	if (locale === "ar") return ar_bespoke_manual_override(inputs)
	if (locale === "id") return id_bespoke_manual_override(inputs)
	if (locale === "it") return it_bespoke_manual_override(inputs)
	if (locale === "ru") return ru_bespoke_manual_override(inputs)
	if (locale === "pt") return pt_bespoke_manual_override(inputs)
	return ko_bespoke_manual_override(inputs)
});